import { FC } from 'react' // we need this to make JSX compile
import { Tenant } from 'common/tenant'
import { Constants, getFullAddress } from 'common/utils/constants'

type OurAddressType = {
  tenant?: Tenant
  className?: string
}

const OurAddress: FC<OurAddressType> = ({ tenant = Tenant.UK, className }) => {
  return (
    <h3 className={className}>
      <svg
        className='me-1 mb-1'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M11 6V2H1V20H15V18H11V16H13V14H11V12H13V10H11V8H19V14H21V6H11ZM5 18H3V16H5V18ZM5 14H3V12H5V14ZM5 10H3V8H5V10ZM5 6H3V4H5V6ZM9 18H7V16H9V18ZM9 14H7V12H9V14ZM9 10H7V8H9V10ZM9 6H7V4H9V6ZM23 18V20H21V22H19V20H17V18H19V16H21V18H23ZM17 10H15V12H17V10ZM17 14H15V16H17V14Z'
          fill='#1D1D1F'
        />
      </svg>
      {tenant === Tenant.AU ? getFullAddress(Tenant.AU) : ukShortAddress()}
    </h3>
  )
}

// Short form: street, city and postcode district, without the building number
function ukShortAddress() {
  const { city, postcode, street } = Constants.location(Tenant.UK)
  return `${street}, ${city}, ${postcode}`
}

export default OurAddress
